import { UI } from '../UI';

export const DataTableColumns = {
  originalFiles: [
    {
      data: '',
      orderable: false,
      sortable: false,
      searchable: false,
      width: 20,
      className: 'text-center',
      render: (data, type, full) => {
        let files = [];
        full.files.forEach((file) => {
          files.push(file.uri);
        });
        return `<label class="kt-checkbox kt-checkbox--danger mb-4 mt-1 p-0 pr-3"><input name="originalfiles" data-fileuri="${files}" type="checkbox"><span></span></label>`;
      }
    },
    {
      title: '',
      data: 'asset.thumbnailImageUri',
      orderable: false,
      sortable: false,
      searchable: false,
      width: 20,
      render: (data, type, full) => {
        let img = null;
        if (full.assetType == 'Artwork') {
          img = full.asset.thumbnailImageUri;
        } else if (full.assetType == 'Trim' || full.assetType == 'Stamp' || full.assetType == 'Hang Tag') {
          let file = full.asset.files.filter((item) => item.fileType == 0); // Take low-res image for thumbnail
          if (file && file.length > 0) {
            img = file[0]?.uri;
          } else {
            img = full.asset?.files[0]?.uri;
          }
        } else if (full.assetType == 'Blank') {
          img = full?.files[0]?.uri;
        }

        return UI.thumbnail(img);
      }
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.AssetType,
      data: 'assetType',
      orderable: false,
      sortable: false,
      searchable: false
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.AssetName,
      data: 'asset.title',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.SystemID,
      data: 'asset.standartId',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.AssetOwner,
      data: 'assetOwner',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.Brand,
      data: 'asset.brand',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.Download,
      data: { files: 'files' },
      orderable: false,
      sortable: false,
      searchable: false,
      width: 20,
      render: (data, type, full) => {
        let files = [];
        data.files.forEach((file, index, list) => {
          files.push(file.uri);
        });
        return `<a href="javascript:" class="js-action-downloadOriginalfile btn btn-sm btn-hover-brand text-nowrap" data-fileurl="${files}">
                  <i class="fal fa-cloud-download"></i> ${$Lang.MasterProductData.OriginalFilesGroup.Columns.Download}
                </a>`;
      }
    },
    {
      title: $Lang.MasterProductData.OriginalFilesGroup.Columns.Remove,
      data: { id: 'assetId', type: 'assetType' },
      orderable: false,
      sortable: false,
      searchable: false,
      width: 20,
      render: (data, type, full) => {
        return (
          '<a href="javascript:" class="btn btn-sm btn-hover-danger bbw-border-radius text-nowrap"><i class="fal fa-trash-alt"></i>' +
          $Lang.MasterProductData.OriginalFilesGroup.Columns.Remove +
          '</a>'
        );
      }
    },
    {
      title: '',
      data: { id: 'assetId', type: 'assetType' },
      orderable: false,
      sortable: false,
      searchable: false,
      className: 'text-right',
      width: 20,
      render: (data, type, full) => {
        return '<a href="javascript:" class="details-control"><i class="fas fa-caret-circle-down fa-lg"></i></a>';
      }
    }
  ]
};
